import classNames from 'classnames'
import { FormikProps } from 'formik'
import { NumericFormat } from 'react-number-format'
import { getCurrencySymbol } from '../../helpers'
import {
  CreateProductValues,
  ProductDiscountType,
} from '../../redux-toolkits/products/products.type'
import Icon from '../icon'
import { Checkbox } from '../inputs/Checkbox'
import Dropdown from '../inputs/dropdown'
import { TextInput } from '../inputs/textInput'
import { HeaderSubheader } from '../typography/HeaderSubheader'

const discountTypeOptions: {
  name: string
  value: ProductDiscountType
}[] = [
  {
    name: 'Amount',
    value: 'constant',
  },
  {
    name: 'Percentage',
    value: 'percent',
  },
]

export const ManageProductPriceSlash = ({
  formik,
  className,
  typeTitle,
}: {
  formik: FormikProps<CreateProductValues>
  className?: string
  typeTitle: string
}) => {
  const { values, errors, setFieldValue, handleBlur, handleChange, touched } =
    formik

  return (
    <div
      className={classNames(
        'flex flex-col gap-6 pb-10 border-b border-divider-gray',
        className,
      )}
    >
      <HeaderSubheader
        title={`${typeTitle} Price Slash`}
        text={`Apply a discounted price to this ${typeTitle}.`}
      />

      <Checkbox
        checkStatus={values.hasDiscount}
        text="Discount product price?"
        handleChange={(status) => {
          setFieldValue('hasDiscount', status)
        }}
        className="w-full"
      />

      {values.hasDiscount ? (
        <div className="col-span-full flex gap-4 items-start max-w-[500px]">
          <NumericFormat
            suffix={
              values.discountDetails?.discountType === 'percent'
                ? '%'
                : undefined
            }
            prefix={
              values.discountDetails?.discountType === 'percent'
                ? undefined
                : getCurrencySymbol('NGN')
            }
            customInput={TextInput}
            type="text"
            name="discountDetails.discountValue"
            placeholder="Enter Discount Value"
            value={values.discountDetails?.discountValue}
            onBlur={handleBlur}
            onChange={handleChange}
            errors={
              typeof errors.discountDetails === 'object' &&
              touched.discountDetails?.discountValue
                ? errors.discountDetails?.discountValue
                : ''
            }
            hasIcon={false}
            decimalScale={2}
            thousandSeparator
          />

          <Dropdown
            loading={false}
            className=""
            menuClassName="!max-h-[200px]"
            menuButton={
              <TextInput
                type="text"
                name="discountDetails.discountType"
                placeholder="Discount type"
                value={
                  discountTypeOptions.find(
                    (o) => o.value === values.discountDetails.discountType,
                  )?.name
                }
                onBlur={() => {}}
                onChange={() => {}}
                errors={
                  typeof errors.discountDetails === 'object'
                    ? errors.discountDetails?.discountType
                    : ''
                }
                hasIcon={false}
                readOnly
                extra={
                  <Icon
                    id={'left-caret'}
                    width={16}
                    height={16}
                    className="-rotate-90 text-sec-black"
                  />
                }
                className="!border-divider-gray"
              />
            }
            menuItems={discountTypeOptions.map((opt) => ({
              ...opt,
              onClick: () => {
                setFieldValue('discountDetails.discountType', opt.value)
              },
            }))}
          />
        </div>
      ) : undefined}
    </div>
  )
}
